exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\n\tbackground: #fff;\n\tborder-top: 1px solid #d2d2d2;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 10px 25px;\n  position: fixed;\n  z-index: 930;\n}\nfooter p {\n\tmargin: 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/defaults/footer/footer.component.css
// module id = ../../../../../angular/app/components/defaults/footer/footer.component.css
// module chunks = 1